export default __webpack_public_path__ + "static/secondSec-be5b9fcf72e4e21408b976ebc1e1b07f.png";